document.addEventListener("DOMContentLoaded", function() {
    // 1. Nhập ID của các offer (rule-id) mà bạn muốn đổi tiêu đề vào mảng này
    const targetOfferIds = ["25420", "25419"]; 
    
    // 2. Nhập nội dung tiêu đề mới bạn muốn đổi
    const newTitleText = "PWP"; 
    
    function updateWidgetTitle() {
      targetOfferIds.forEach(offerId => {
        // Tìm element chứa offer cụ thể trên màn hình
        const offerItem = document.querySelector(`.salepify-embed-widget__item[rule-id="${offerId}"]`);
        
        if (offerItem) {
          // Tìm widget container bao bọc offer này
          const container = offerItem.closest('.salepify-embed-widget__embedded-list-container');
          
          if (container) {
            // Tìm thẻ tiêu đề Offer
            const headerTitle = container.querySelector('.salepify-embed-widget__header-title');
            
            if (headerTitle) {
              // Thay đổi text nhưng vẫn giữ lại các icon bên trong (ví dụ icon ngọn lửa nếu có)
              let textChanged = false;
              Array.from(headerTitle.childNodes).forEach(node => {
                // Đổi chữ của phần text node
                if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
                  if (node.textContent.trim() !== newTitleText) {
                    node.textContent = ` ${newTitleText} `;
                    textChanged = true;
                  }
                }
              });
              
              // Dự phòng: Nếu thẻ không chứa text node rõ ràng mà chỉ có chữ
              if (!textChanged && !headerTitle.querySelector('img') && headerTitle.innerText.trim() !== newTitleText) {
                  headerTitle.innerText = newTitleText;
              }
            }
          }
        }
      });
    }

    // Do app Free Gift hiển thị widget bị delay (bất đồng bộ), ta cần dùng MutationObserver 
    // để theo dõi và tự động đổi chữ ngay khi widget vừa xuất hiện.
    const observer = new MutationObserver(function(mutations) {
      updateWidgetTitle();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    
    // Chạy thử 1 lần đề phòng widget đã load sẵn
    updateWidgetTitle();
  });